import {AiTemplate, Rubric} from "../../utils/types/AiTypes";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {API_RUBRIC_LIST_ENDPOINT} from "../../utils/constants";

export interface RubricsState {
    rubrics: Rubric[];
    currentPage: number,
    size: number
    totalPage: number,
    totalElements: number,
    status: "fulfilled" | "pending" | "rejected" | "idle";
}

interface RubricListPagination {
    data: AiTemplate[],
    currentPage: number,
    totalPage: number,
    totalElements: number,
}

const initialState: RubricsState = {
    rubrics: [],
    currentPage: 1,
    size: 10,
    totalPage: 1,
    totalElements: 0,
    status: "idle"
}

export const fetchRubricsByGenreAndPublished = createAsyncThunk(
    "rubric/fetchRubricsByModelTypeAndGenreAndPublished",
    async (params: {keycloak: Keycloak.KeycloakInstance, genre?: string, packageId?: number, published?: boolean | undefined , page: number, size: number}): Promise<RubricListPagination> => {
        const {keycloak, genre, packageId, published, page, size} = params;
        const res = await axios.get(`${API_RUBRIC_LIST_ENDPOINT}`, {
            params: {
                genre: genre,
                packageId: packageId,
                published: published,
                page: page,
                size: size
            },
            headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                Authorization: `Bearer ${keycloak?.token}`,
            },
            withCredentials: true,
        });
        return res.data;
    }
);


export const RubricSlice = createSlice({
    name: 'aiTemplates',
    initialState,
    reducers: {
        getRubrics: (state, action) => {
            state.status = 'fulfilled';
            state.rubrics = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalPage = action.payload.totalPage;
        },
        failedToGetRubrics: (state) => {
            state.status = 'rejected';
            state = initialState
        },
        resetRubricsState: (state) => {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRubricsByGenreAndPublished.fulfilled, (state, action) => {
            state.status = "fulfilled";
            state.rubrics = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalPage = action.payload.totalPage;
            state.totalElements = action.payload.totalElements;
        })
    }
});

export const { getRubrics, failedToGetRubrics,resetRubricsState} = RubricSlice.actions;
export default RubricSlice.reducer;